/* eslint-disable react/prop-types */
import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { IconButton } from '@material-ui/core';
import Icon from '@mdi/react';

import { mdiChevronRight, mdiChevronLeft } from '@mdi/js';

const useStyles = makeStyles((theme) => ({
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  overlayLeft: {
    position: 'absolute',
    left: 4,
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: 25,
    color: '#fff',
    background: 'rgba(0,0,0,0.35)',
    pointerEvents: 'auto',
    '&:hover, &:focus': {
      background: 'rgba(0,0,0,0.5)',
    },
  },
  overlayRight: {
    position: 'absolute',
    right: 4,
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: 25,
    color: '#fff',
    background: 'rgba(0,0,0,0.35)',
    pointerEvents: 'auto',
    '&:hover, &:focus': {
      background: 'rgba(0,0,0,0.5)',
    },
  },
}));

// eslint-disable-next-line react/prop-types
export function NavigateButtons({
  isFirstFilePermission,
  isLastFilePermission,
  changeSelectedMediaFilePermission,
  overlay,
}) {
  const classes = useStyles();

  const handleNavigate = (e, step) => {
    e.stopPropagation();
    changeSelectedMediaFilePermission(step);
  };

  if (overlay) {
    return (
      <>
        {!isFirstFilePermission ? (
          <IconButton
            className={classes.overlayLeft}
            onClick={(e) => handleNavigate(e, -1)}
            size="medium"
          >
            <Icon path={mdiChevronLeft} size={1} />
          </IconButton>
        ) : null}
        {!isLastFilePermission ? (
          <IconButton
            className={classes.overlayRight}
            onClick={(e) => handleNavigate(e, 1)}
            size="medium"
          >
            <Icon path={mdiChevronRight} size={1} />
          </IconButton>
        ) : null}
      </>
    );
  }

  return (
    <div className={classes.buttonContainer}>
      {!isFirstFilePermission ? (
        <IconButton
          onClick={() => changeSelectedMediaFilePermission(-1)}
          size="medium"
        >
          <Icon path={mdiChevronLeft} size={1} />
        </IconButton>
      ) : null}
      {!isLastFilePermission ? (
        <IconButton
          onClick={() => changeSelectedMediaFilePermission(1)}
          size="medium"
        >
          <Icon path={mdiChevronRight} size={1} />
        </IconButton>
      ) : null}
    </div>
  );
}
